import { render, staticRenderFns } from "./SingleNavbar.vue?vue&type=template&id=397c380a&"
import script from "./SingleNavbar.vue?vue&type=script&lang=js&"
export * from "./SingleNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SingleNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports